export default __webpack_public_path__ + "static/media/Jack_of_hearts.6710e078.svg";